import { render, staticRenderFns } from "./CommentInputEdit.vue?vue&type=template&id=53d52d70"
import script from "./CommentInputEdit.vue?vue&type=script&lang=js"
export * from "./CommentInputEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports